import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().trim().toLowerCase().email("Adresse électronique invalide"),
  password: z.string().min(12, 'Le mot de passe doit contenir au moins 12 caractères'),
})

export type LoginInput = z.infer<typeof loginSchema>
